<template>
    <card>
        <form
            :class="isEditing ? '' : 'view-only-form'"
            @submit.prevent=""
            autocomplete="off"
        >
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        id="description"
                        name="description"
                        label="Description"
                        v-model="receiptLogUnitEdit.description"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="length"
                        name="length"
                        type="text"
                        label="Length"
                        v-model="receiptLogUnitEdit.length"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="width"
                        name="width"
                        type="text"
                        label="Width"
                        v-model="receiptLogUnitEdit.width"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="height"
                        name="height"
                        type="text"
                        label="Height"
                        v-model="receiptLogUnitEdit.height"
                        :disabled="!isEditing"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        id="manufacturer"
                        name="manufacturer"
                        type="text"
                        label="Manufacturer"
                        :value="
                            receiptLogUnit.manufacturer
                                ? receiptLogUnit.manufacturer.name
                                : ''
                        "
                        :disabled="true"
                    />
                </div>
                <div class="col-md-3">
                    <base-input
                        id="relatedNumber"
                        name="relatedNumber"
                        type="text"
                        label="S/N"
                        v-model="receiptLogUnitEdit.relatedNumber"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-3">
                    <base-input
                        id="trackingNumber"
                        name="trackingNumber"
                        type="text"
                        label="Tracking No."
                        v-model="receiptLogUnitEdit.trackingNumber"
                        :disabled="!isEditing"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <base-input
                        id="itemNumber"
                        name="itemNumber"
                        type="text"
                        label="Item No."
                        v-model="receiptLogUnitEdit.itemNumber"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-3">
                    <base-input
                        id="roomNumber"
                        name="roomNumber"
                        type="text"
                        label="Room"
                        v-model="receiptLogUnitEdit.roomNumber"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="lotNumber"
                        name="lotNumber"
                        type="text"
                        label="Lot No."
                        v-model="receiptLogUnitEdit.lotNumber"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="stickerColor"
                        name="stickerColor"
                        type="text"
                        label="Sticker Color"
                        v-model="receiptLogUnitEdit.stickerColor"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <base-input
                        id="stickerNumber"
                        name="stickerNumber"
                        type="text"
                        label="Sticker No."
                        v-model="receiptLogUnitEdit.stickerNumber"
                        :disabled="!isEditing"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <base-input
                        id="quantity"
                        name="quantity"
                        type="text"
                        label="Qty"
                        v-model="receiptLogUnitEdit.quantity"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-3">
                    <base-input
                        id="date"
                        name="date"
                        type="text"
                        label="Received"
                        :value="formatDate(receiptLogUnitEdit.date)"
                        :disabled="!isEditing"
                    />
                </div>
                <div class="col-md-2">
                    <label>Damaged?</label>
                    <base-input
                        id="damaged"
                        name="damaged"
                        :disabled="!isEditing"
                    >
                        <select
                            id="selectDamaged"
                            class="form-control"
                            v-model="receiptLogUnitEdit.damaged"
                            :disabled="!isEditing"
                        >
                            <option value="-1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </base-input>
                </div>
                <div class="col-md-5">
                    <base-input
                        v-if="hasDeliveryLog"
                        id="deliveryLogId"
                        name="deliveryLogId"
                        type="text"
                        label="Delivery Log"
                        v-model="receiptLogUnitEdit.deliveryLogId"
                        :disabled="true"
                    />
                    <div v-else-if="receiptLogUnit.deliveryRequested">
                        <base-input
                            name="deliveryLogRequested"
                            type="text"
                            label="Delivery Log"
                            value="This unit has been requested for delivery."
                            :disabled="true"
                        />
                    </div>
                    <div v-else>
                        <label>Delivery Log</label>
                        <base-button
                            id="requestDelivery"
                            type="primary"
                            class="btn-fill d-block"
                            @click="$emit('requestDelivery')"
                        >
                            Request Delivery
                        </base-button>
                    </div>
                </div>
            </div>
        </form>
    </card>
</template>
<script>
import _ from "lodash";
import moment from "moment-timezone";

export default {
    name: "ReceiptLogUnitDetailForm",
    props: {
        receiptLogUnit: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isEditing: false,
            receiptLogUnitEdit: _.cloneDeep(this.receiptLogUnit),
        };
    },
    computed: {
        hasDeliveryLog() {
            return (
                this.hasDeliveryLogDownload ||
                (Number(this.receiptLogUnitEdit.deliveryLogId) !== 0 &&
                    this.receiptLogUnitEdit.deliveryLogId !== null &&
                    this.receiptLogUnitEdit.deliveryLogId !== undefined)
            );
        },
        hasDeliveryLogDownload() {
            if (this.receiptLogUnitEdit.files) {
                return (
                    this.receiptLogUnitEdit.files.findIndex(
                        (file) => file.name === "Delivery Log",
                    ) !== -1
                );
            }
            return false;
        },
    },
    watch: {
        receiptLogUnit(update) {
            this.receiptLogUnitEdit = _.cloneDeep(update);
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
    },
};
</script>
